import React from 'react'

const BhutaniFilmCity = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <h1 className="text-4xl font-bold text-gray-800">BhutaniFilmCity</h1>
            <p className="text-lg text-gray-600 mt-4">Coming Soon...</p>
        </div>
    )
}

export default BhutaniFilmCity